"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueId = void 0;
var counter = 0;
// lodash uniqueId lol
var uniqueId = function (prefix) {
    var id = ++counter; // eslint-disable-line
    return prefix + id;
};
exports.uniqueId = uniqueId;
